import {
  Badge,
  Box,
  Icon,
  PreviewCard,
  PreviewContent,
  PreviewImage,
  Skeleton,
  Text,
} from "@prismicio/editor-ui"

import type { IntegrationItem } from "./integrationData"

interface Props {
  item: IntegrationItem
  catalogId: string
  onClick?: () => void
}

export function IntegrationPreviewCard(props: Props) {
  const { item, onClick, catalogId } = props

  return (
    <PreviewCard variant="large" onClick={onClick}>
      <IntegrationPreviewImage src={item.imageURL ?? ""} alt={item.title} />
      <PreviewContent>
        <Badge
          title={`Catalog: ${catalogId}`}
          icon="multipleStop"
          size="medium"
        />
        <Text variant="bold" color="grey12" sx={{ marginTop: 4 }}>
          {item.title}
        </Text>
        <Text variant="small" color="grey11">
          {item.description ?? item.id}
        </Text>
      </PreviewContent>
    </PreviewCard>
  )
}

interface IntegrationPreviewImageProps {
  src?: string
  alt?: string
}

const imageSize = 76

function IntegrationPreviewImage(props: IntegrationPreviewImageProps) {
  const { src, alt } = props

  if (!src) {
    return (
      <Box
        borderRadius={6}
        backgroundColor="grey2"
        height={imageSize}
        width={imageSize}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        border
        padding={{ inline: 4, block: 8 }}
      >
        <Icon name="hideImage" size="large" color="grey11" />
        <Text color="grey11" variant="small" noSelect align="center">
          No preview image
        </Text>
      </Box>
    )
  }

  return (
    <PreviewImage
      src={src}
      alt={alt}
      width={imageSize}
      height={imageSize}
      framed
    />
  )
}

export function IntegrationPreviewCardSkeleton() {
  return (
    <PreviewCard variant="large">
      <Skeleton height={76} width={76} />
      <PreviewContent>
        <Skeleton height={24} width={168} />
        <Skeleton height={24} width={240} sx={{ marginTop: 4 }} />
        <Skeleton height={16} width={144} />
      </PreviewContent>
    </PreviewCard>
  )
}
